export type CampaignDialogMessages = {
  //Title messages
  deleteCampaignDialogTitle: string;

  //Dialog content messages
  deleteCampaignDialogContent: string;
  deleteCampaignDialogCancel: string;
  deleteCampaignDialogConfirm: string;
  deleteCampaignSuccess: string;
};

export const CAMPAIGN_DIALOG_MESSAGES: CampaignDialogMessages = {
  //Title messages
  deleteCampaignDialogTitle: "Excluir Campanha",

  //Dialog content messages
  deleteCampaignDialogContent: "Você tem certeza que deseja excluir esta campanha?",
  deleteCampaignDialogCancel: "Cancelar",
  deleteCampaignDialogConfirm: "Confirmar",
  deleteCampaignSuccess: "Campanha excluída com sucesso",
};
